@if (!cmnHidden) {
  <div id="{{cmsgFieldId}}" class="pageMessage info userHasNotSeenMessage" tabindex="0" (keydown.Tab)="onTabKey($event)">
    <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
    <span class="sr-only" [innerHTML]="iconText"></span>
    <span>
      <ng-content></ng-content>
    </span>
  </div>
}